export default __webpack_public_path__ + "static/media/arrow-down-blue.18b75108.svg";